export function combineValidators(...funcs) {
  if (funcs.length === 1) {
    return funcs[0];
  }

  return function combination(...args) {
    return funcs.reduce((prev, validator) => {
      return prev || validator(...args);
    }, '');
  }
}
